import { Component, Input, OnInit } from '@angular/core';
import { CoreServices } from 'flx-engine';
import { tap } from 'rxjs/operators';
// import { SetCurrentPage } from '@flexus/ux';

@Component({
  selector: 'app-footer',
  templateUrl: 'app-footer.component.html',
  styleUrls: ['app-footer.component.scss']
})
export class AppFooterComponent implements OnInit {
  activeNode$;
  compInstances$;
  constructor(private svc: CoreServices) {}

  ngOnInit() {
    this.activeNode$ = this.svc.footerAccessor.nodeForFooter.pipe(tap(xy => console.log({xy})));
    this.compInstances$ = this.svc.footerAccessor.compInstances;
  }

  setCurrentPage(currentPage: number) {
    this.svc.footerAccessor.setPage(currentPage);
  }
}
